import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    modalfeedback: null,
    cropfeedback: null,
    mustUpdate: null,
    config: null
  },
  mutations: {
    setModalFeedback (state, itm) {
      state.modalfeedback = itm
    },
    setCropFeedback (state, itm) {
      state.cropfeedback = itm
    },
    setMustUpdate (state, itm) {
      state.mustUpdate = itm
    },
    setConfig (state, itm) {
      state.config = itm
    }
  },
  actions: {
    changeFlag ({ commit }, flag) {
      commit('setMustUpdate', flag)
    },
    changeConfig ({ commit }, payload) {
      commit('setConfig', payload)
    }
  },
  getters: {
    getMustUpdate (state) {
      return state.mustUpdate
    },
    getConfig (state) {
      return state.config
    }
  }
})
//

export default store



// WEBPACK FOOTER //
// ./src/storevuex/index.js